import {
  createSelector
} from 'reselect'
import {
  getAllEntries
} from '../orders/selectors'
const namespace = 'conversations'

export const getState = state => state[namespace]

export const getConvIdsSelector = createSelector(
  getState,
  state => {
    return state
      .get('unpinned')
      .concat(state.get('pinned'))
      .reverse()
  }
)

export const getConvEntriesSelector = createSelector(
  getState,
  state => state.get('entries')
)

export const getConvByIdSelector = id => createSelector(
  getConvEntriesSelector,
  convs => convs.get(id)
)

export const getConvByOrderIdSelector = orderId => createSelector(
  getConvEntriesSelector,
  convs => convs.find(item => item.get('order_id') === orderId)
)

export const firstConvSelector = createSelector(
  getConvIdsSelector,
  convIds => convIds.first()
)

export const currentConvIdSelector = createSelector(
  getState,
  state => state.get('currentId')
)

export const currentConvSelector = createSelector(
  [getState, currentConvIdSelector],
  (state, currentConvId) => state.getIn(['entries', currentConvId])
)

export const currentOrderIdSelector = createSelector(
  getState,
  state => state.get('displayOrderId')
)

export const isActiveSelector = id => createSelector(
  [currentConvIdSelector],
  currentConvId => currentConvId === id
)

export const currentOrderSelector = createSelector(
  [currentConvSelector, getAllEntries],
  (conv, orders) => orders.get(conv && conv.get('order_id'))
)

export const orderOfConvSelector = id => createSelector(
  [getAllEntries, getConvEntriesSelector],
  (orders, convs) => orders.get(convs.getIn([id, 'order_id']))
)

export const totalUnreadCountSelector = createSelector(
  [getConvEntriesSelector],
  convs => convs.reduce((total, item) => {
    return total + item.get('unread_count')
  }, 0)
)

export const getConvStats = type => createSelector(
  getState,
  state => state.getIn(['convs_stats', type])
)

export const getConvQueryTypeSelector = createSelector(
  getState,
  state => state.get('convs_query_type')
)

export const convRefreshKeySelector = createSelector(
  getState,
  state => {
    return state.get('convRefreshKey')
  }
)